// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { useEffect, useState } from "react";

import { ShowError } from "../../../components/error";
import { Title } from "./title";
import { Value } from "./value";
import { fetchHcfDetails } from "./api";
import { Stack } from "@mui/material";
import { handleApiError } from "src/utils/errors";

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'hcfId' implicitly has an 'any' type.
function LateCancelCharge({ hcfId, updateFacility }) {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [details, setDetails] = useState<any>();
  const [error, setError] = useState();

  useEffect(() => {
    fetchHcfDetails(hcfId, "lateCancellation").then(setDetails).catch(setError);
  }, [hcfId]);

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'data' implicitly has an 'any' type.
  const updateLocal = (data) => {
    // `data` is undefined if saveFacility's retrieveUser refresh failed
    // (swallowed there). Leave local state alone in that case.
    if (!data?.facility) {
      return;
    }
    // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'prev' implicitly has an 'any' type.
    setDetails((prev) => ({
      ...prev,
      lateCancellation: data.facility.lateCancellation,
    }));
  };

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'data' implicitly has an 'any' type.
  const handleChange = (data) => {
    updateFacility({
      facilityId: hcfId,
      lateCancellation: data,
    })
      .then(updateLocal)
      .catch(handleApiError);
  };

  return (
    <Stack>
      <Title>Shift Late Cancel Charge</Title>
      <ShowError error={error} message="Unable to fetch workplace Late Cancel Charge" />
      <p className="content">
        Shift cancelled within
        <Value name="period" onChange={handleChange} value={details?.lateCancellation?.period} />
        hrs of shift start will be billed for
        <Value
          name="feeHours"
          onChange={handleChange}
          value={details?.lateCancellation?.feeHours}
        />
        hrs at the Workplace Total Charge.
      </p>
    </Stack>
  );
}

export { LateCancelCharge };
